<template>
    <div class="card">
        <DataTable :value="draft_tasks" responsiveLayout="scroll">
            <template #empty> No tasks available. </template>
            <template #loading> Loading tasks. Please wait. </template>
            <Column field="id" header="TASK ID" sortable style="max-width: 5rem" />
            <Column field="title" header="TASK TITLE" sortable style="max-width: 15rem" />
            <Column field="actions" header="ACTIONS" style="width: 8rem">
                <template #body="slotProps">
                    <span class="p-column-title">ACTIONS</span>
                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editTask(slotProps.data)" v-tooltip="`Edit ${label('Task')}`" />
                </template>
            </Column>
        </DataTable>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { taskStore } from '../../../../../store/global-stores';
import { useLabels } from '@/composables/LabelComposable';

const { label } = useLabels();

const { draft_tasks, draftTaskDetails } = storeToRefs(taskStore);
const router = useRouter();
onMounted(() => {
    loadDraftTask();
});

const loadDraftTask = async () => {
    await taskStore.getDraftTasks();
};

const editTask = async (taskData) => {
    draftTaskDetails.value = taskData;
    router.push({ name: 'TaskForm', query: { taskId: taskData.id, draft: true } });
};
</script>
